<template>
  <img src="/images/hip.png">
</template>

<script>
  export default {
    name: "Hip",
  }
</script>
